export default __webpack_public_path__ + "static/media/8-2-chair-high-quality-png 1.34bed2e2.png";